/* eslint-disable jsx-a11y/role-supports-aria-props   */

import React from "react";

export const ValidationErrorMessage = ({message, id}) => {
    console.log(">>>> message>>>", message);
  return (
    <p
      aria-live="polite"
      id={id}
      className="form-validation-error___2YuJL"
    >
      <span className="validation-icon___3zpVI">
        <span className="icon___66GYG icon-sm___3uA1E icon-Inherit___1UF-f ">
          <svg
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="currentColor"
            role="none"
            focusable="false"
            aria-hidden="true"
          >
            <path d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346 7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"></path>
          </svg>
        </span>
      </span>
      <span className="validation-text___H1nk9">{message}</span>
    </p>
  );
};
